// pipes
import { titleCasePipe } from 'shared/pipes';

// components
import { BodyShapeImages } from './body-shape-images';

const StyleInfoView = ({ title, values }) => (
    <div className="content">
        <dl>
            <dt className="subtitle is-size-4 is-uppercase">{title}</dt>
            <div className="is-flex-mobile is-justify-content-flex-start is-flex-wrap-wrap">
                {values.map((value) => (
                    <dd key={value}>{value}</dd>
                ))}
            </div>
        </dl>
    </div>
);

const PickedStyleInfo = ({ name, data }) => {

    if (!data) { return null; }

    let d = data;
    if (typeof (data) === 'object') {
        d = data.toString();
    }

    const values = d?.split(',') || [];
    const title = titleCasePipe.transform(name);

    if (!values.length) { return null; }

    return (
        <div className="column has-text-centered is-6-mobile">
            <StyleInfoView title={title} values={values} />
        </div>
    );
};

const BodyShape = ({ customer }) => {
    if (!customer || !customer.body_shape) { return null; };

    const { upper_body, lower_body } = customer?.body_shape;

    return (

        <div className="container">

            <p className="title has-text-centered">
                Body Shape
            </p>

            <div className="box">

                <div className="columns is-centered has-background-light is-multiline is-mobile">

                    <div className="column">
                        <PickedStyleInfo name="Upper Body" data={upper_body} />
                        <PickedStyleInfo name="Lower Body nogo" data={lower_body} />
                    </div>
                    <BodyShapeImages customer={customer} />


                </div>

            </div>

        </div>
    );
}

export { BodyShape };
